"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormModelField = exports.FormModelMutatorField = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var array_1 = require("../../util/array");
var FormModelMutatorField = /** @class */ (function () {
    function FormModelMutatorField(field) {
        this.field = field;
    }
    Object.defineProperty(FormModelMutatorField.prototype, "state", {
        get: function () {
            return this.field.getForm().state;
        },
        enumerable: false,
        configurable: true
    });
    FormModelMutatorField.prototype.displayName = function (displayName) {
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { displayName: displayName }));
    };
    FormModelMutatorField.prototype.title = function (title) {
        var e_1, _a;
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { title: title }));
        // Unset other titles if this is the new title
        // Unset the subtitle if this is the new title
        if (title === true) {
            try {
                for (var _b = tslib_1.__values(this.field.parent.fields), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var field = _c.value;
                    if (field.title && field.id !== this.field.id) {
                        field.Mutator.title(false);
                    }
                    if (field.subtitle && field.id === this.field.id) {
                        field.Mutator.subtitle(false);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    FormModelMutatorField.prototype.subtitle = function (subtitle) {
        var e_2, _a;
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { subtitle: subtitle }));
        // Unset other subtitles if this is the new subtitle
        // Unset the title if this is the new subtitle
        if (subtitle === true) {
            try {
                for (var _b = tslib_1.__values(this.field.parent.fields), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var field = _c.value;
                    if (field.subtitle && field.id !== this.field.id) {
                        field.Mutator.subtitle(false);
                    }
                    if (field.title && field.id === this.field.id) {
                        field.Mutator.title(false);
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    };
    FormModelMutatorField.prototype.isStatusField = function (useAsStatus) {
        var _this = this;
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { isStatusField: useAsStatus }));
        if (useAsStatus) {
            this.field.getForm().metadata.setStatusField(this.field);
            this.field.parent.fields.forEach(function (field) {
                if (field.isStatusField && field.id !== _this.field.id) {
                    field.Mutator.isStatusField(false);
                }
            });
        }
        else {
            this.field.getForm().metadata.removeStatusField(this.field);
        }
    };
    FormModelMutatorField.prototype.isMapColorField = function (useAsMapColorField) {
        var _this = this;
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { isMapColorField: useAsMapColorField }));
        if (useAsMapColorField) {
            this.field.getForm().metadata.setMapColorField(this.field);
            this.field.parent.fields.forEach(function (field) {
                if (field.isMapColorField && field.id !== _this.field.id) {
                    field.Mutator.isMapColorField(false);
                }
            });
        }
        else {
            this.field.getForm().metadata.removeMapColorField(this.field);
        }
    };
    FormModelMutatorField.prototype.annotationLabelFieldId = function (annotationLabelFieldId) {
        if (this.field.type === core_api_1.IkeFieldType.HEIGHT || this.field.type === core_api_1.IkeFieldType.VERTICAL_SEPARATION) {
            this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { annotationLabelFieldId: annotationLabelFieldId }));
        }
    };
    FormModelMutatorField.prototype.clearanceThresholdInMeters = function (clearanceThresholdInMeters) {
        if (this.field.type === core_api_1.IkeFieldType.VERTICAL_SEPARATION) {
            this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { clearanceThresholdInMeters: clearanceThresholdInMeters }));
        }
    };
    FormModelMutatorField.prototype.required = function (required) {
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { required: required }));
    };
    FormModelMutatorField.prototype.isAddressLookupField = function (isAddress) {
        var _this = this;
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { isAddressLookupField: isAddress }));
        if (isAddress) {
            this.field.getForm().metadata.setAddressLookupField(this.field);
            this.field.parent.fields.forEach(function (field) {
                if (field.isAddressLookupField && field.id !== _this.field.id) {
                    field.Mutator.isAddressLookupField(false);
                }
            });
        }
        else {
            this.field.getForm().metadata.removeAddressLookupField(this.field);
        }
    };
    FormModelMutatorField.prototype.adminOnly = function (adminOnly) {
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { adminOnly: adminOnly }));
        //Set field as hidden if the field is admin-only
        if (adminOnly) {
            this.field.Mutator.collector(core_api_1.IkeCollectorType.OFFICE);
        }
    };
    FormModelMutatorField.prototype.collector = function (collector) {
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { collector: collector }));
    };
    FormModelMutatorField.prototype.cloneable = function (cloneable) {
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { cloneable: cloneable }));
    };
    /** Overwrite the list of providers with this list */
    FormModelMutatorField.prototype.providers = function (providers) {
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { providers: providers }));
    };
    /** Toggle a specific provider on or off */
    FormModelMutatorField.prototype.provider = function (providerType) {
        var stateValue = this.field.stateValue;
        var providers = array_1.IkeArray.clone(stateValue.providers);
        var foundIndex = providers.findIndex(function (f) { return f.type === providerType; });
        if (foundIndex == null) {
            providers.push({ type: providerType });
        }
        else {
            providers.splice(foundIndex, 1);
        }
        this.state.setFieldValue(this.field.fieldId, tslib_1.__assign(tslib_1.__assign({}, this.field.stateValue), { providers: providers }));
    };
    /** Move the field up one position in the form */
    FormModelMutatorField.prototype.moveUp = function () {
        this.field.parent.Mutator.move(this.field.id, -1);
    };
    /** Move the field up one position in the form */
    FormModelMutatorField.prototype.moveDown = function () {
        this.field.parent.Mutator.move(this.field.id, 1);
    };
    FormModelMutatorField.prototype.delete = function () {
        this.field.parent.Mutator.remove(this.field.id);
    };
    return FormModelMutatorField;
}());
exports.FormModelMutatorField = FormModelMutatorField;
var FormModelField = /** @class */ (function () {
    function FormModelField(parent, id) {
        this.id = id;
        this.parent = parent;
        var metadata = this.getForm().metadata;
        if (metadata && metadata.statusFieldId === id) {
            this.stateValue.isStatusField = true;
        }
        if (metadata && metadata.mapColorFieldId === id) {
            this.stateValue.isMapColorField = true;
        }
        if (metadata && metadata.addressLookupFieldId === id) {
            this.stateValue.isAddressLookupField = true;
        }
    }
    Object.defineProperty(FormModelField.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (value) {
            this._id = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "fieldId", {
        get: function () {
            if (this.parent == null) {
                return ':' + this.id;
            }
            return this.parent.id + ':' + this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "Mutator", {
        get: function () {
            if (this._Mutator == null) {
                this._Mutator = new FormModelMutatorField(this);
            }
            return this._Mutator;
        },
        enumerable: false,
        configurable: true
    });
    FormModelField.prototype.getForm = function () {
        return this.parent.getForm();
    };
    Object.defineProperty(FormModelField.prototype, "displayName", {
        get: function () {
            return this.stateValue.displayName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "title", {
        get: function () {
            return this.stateValue.title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "subtitle", {
        get: function () {
            return this.stateValue.subtitle;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "isStatusField", {
        get: function () {
            return this.stateValue.isStatusField;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "isMapColorField", {
        get: function () {
            return this.stateValue.isMapColorField;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "required", {
        get: function () {
            return this.stateValue.required;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "isAddressLookupField", {
        get: function () {
            return this.stateValue.isAddressLookupField;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "adminOnly", {
        get: function () {
            return this.stateValue.adminOnly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "collector", {
        get: function () {
            return this.stateValue.collector;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "annotationLabelFieldId", {
        get: function () {
            return this.stateValue.annotationLabelFieldId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "clearanceThresholdInMeters", {
        get: function () {
            return this.stateValue.clearanceThresholdInMeters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "cloneable", {
        get: function () {
            return this.stateValue.cloneable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "providers", {
        get: function () {
            return this.stateValue.providers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "type", {
        get: function () {
            return this.stateValue.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "isCloneable", {
        get: function () {
            var cloneable = this.stateValue.cloneable;
            return cloneable != null && cloneable !== core_api_1.IkeCloneable.NONE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "isRoot", {
        get: function () {
            return this.parent.parent == null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FormModelField.prototype, "stateValue", {
        get: function () {
            return this.getForm().state.getFieldValue(this.fieldId);
        },
        enumerable: false,
        configurable: true
    });
    return FormModelField;
}());
exports.FormModelField = FormModelField;
//# sourceMappingURL=form.field.js.map